import React, { useEffect } from "react"

const useTabsAutoScroll = (current: number, tabRefs: React.MutableRefObject<(HTMLButtonElement | null)[]>) => {
  const isFirstTabsScroll = React.useRef(true)

  useEffect(() => {
    if (typeof window === "undefined") return
    if (window.innerWidth > 1100) return

    if (isFirstTabsScroll.current) {
      isFirstTabsScroll.current = false
      return
    }

    const el = tabRefs.current[current]
    if (!el) return

    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    })
  }, [current, tabRefs])
}

export default useTabsAutoScroll
